import {request, serviceUrl} from "@/utils/request";

//根据页面url获取页面
export function getCustomPage(page) {
  return request({
    url: serviceUrl.deviceService + '/device/custom-page',
    params: {
      page: page
    }
  })
}

//保存或者更新自定义页面信息
export function saveOrUpdateCustomPage(params) {
  return request({
    url: serviceUrl.deviceService + '/device/custom-page',
    method: 'post',
    data: params
  })
}

//页面列表
export function getCustomListByPage(page) {
  return request({
    url: serviceUrl.deviceService + '/device/custom-page/listByPage',
    params: {
      page: page
    }
  })
}

//获取大屏页面
export function getCurrentCustomPage(code) {
  return request({
    url: serviceUrl.deviceService + '/device/custom-page/getCurrentCustomPage',
    params: {
      page: code
    }
  })
}

// 初始化自定义页面信息
export function initializeCustomPage(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/custom-page/initializeCustomPage',
    data: params
  })
}

// 新增自定义页面信息
export function saveCustomPage(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/custom-page/saveCustomPage',
    data: params
  })
}

// 新增自定义页面信息
export function savePage(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/custom-page',
    data: params
  })
}

// 编辑自定义页面信息
export function updateCustomPage(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/custom-page/updateCustomPage',
    data: params
  })
}

// 编辑自定义页面信息(简单信息，不包括各组件位置)
export function updateCustomPageById(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/device/custom-page/updateCustomPageById',
    data: params
  })
}


//修改使用模板
export function useCustomPage(code, pageId) {
  return request({
    url: serviceUrl.deviceService + '/device/custom-page/useCustomPage',
    params: {
      code, pageId
    }
  })
}

// 删除模板 customPageId 模板id
export function deleteByDeviceCustomPageId(customPageId) {
  return request({
    method: 'DELETE',
    url: serviceUrl.deviceService + '/device/custom-page/deleteByDeviceCustomPageId',
    params: {customPageId}
  })
}

// 根据页面及组件名称，删除自定义页面参数
export function deleteByPageAndComponentName(page, componentName) {
  return request({
    method: 'DELETE',
    url: serviceUrl.deviceService + '/device/custom-page/deleteByPageAndComponentName',
    params: {page, componentName}
  })
}
